import React, { FC } from 'react';
import { RouterLocation } from '@funtech-int/rival';

import rightArrow from '@/shared/assets/rightArrow.svg';

import * as CardKit from '../CardKit';
import { useI18n } from '../../hooks/useI18n';

import styles from './_ShowAll.module.css';

interface ShowAllProps {
    location: RouterLocation<any, any>;
    searchParams?: URLSearchParams;
    onClick?(): void;
}

export const ShowAll: FC<ShowAllProps> = ({ location, searchParams, onClick }) => {
    const i18n = useI18n();

    return (
        <CardKit.Layout
            location={location}
            searchParams={searchParams}
            onClick={onClick}
            className={styles.root}
            dataTid="ShowAll"
        >
            <div className={styles.wrapper}>
                <span className={styles.arrow}>
                    <img src={rightArrow} alt="" className={styles.arrowIcon} />
                </span>
                <p className={styles.text}>{i18n('card__show_all')}</p>
            </div>
        </CardKit.Layout>
    );
};
